<template>
  <div class="form-group">
    <slot name="label">
      <label v-if="label" class="control-label" :class="{ required: isRequired }">
        <i  v-if="tooltip" v-tooltip="{ content: tooltip, offset: 0}" class="nc-icon nc-chart text-plyo"></i>{{label}}
      </label>
      <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
    </slot>
  </div>
</template>

<script>
  export default {
    name: "file-group",
    props: {
      label: String,
      tooltip: String,
      isRequired: Boolean,
    },
    methods: {
      handleFileUpload() {
        this.$emit('handleFileUpload', this.$refs.file.files[0])
      }
    }
  }
</script>
